<template>
  <div>
    <Question
      :question="question"
      :index="index"
    />
    <div>
      <VRadioGroup v-if="question.type === testQuestionTypes.SELECT" v-model="answer">
        <VRadio
          v-for="answer in question.answers"
          :key="answer.id"
          :disabled="disabledAnswers"
          :label="answer.answer"
          :value="`${answer.id}`.toString()"
          @click="answerQuestion()"
        />
      </VRadioGroup>

      <div v-else-if="question.type === testQuestionTypes.MULTISELECT">
        <VCheckbox
          v-for="answer in question.answers"
          :key="answer.id"
          v-model="selectedAnswers"
          :disabled="disabledAnswers"
          :label="answer.answer"
          :value="`${answer.id}`.toString()"
          @click="answerQuestion()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, toRefs, computed, onMounted,
} from '@vue/composition-api';
import { testQuestionTypes } from '../../enums';
import Question from './Question.vue';

export default {
  name: 'SelectQuestion',
  components: {
    Question,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    disabledAnswers: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { question, answers } = toRefs(props);
    const selectedAnswers = ref([]);
    const answer = ref(null);

    const isEmptyQuestion = computed(() => !answer.value && !selectedAnswers.value.length);

    const isValid = computed(() => !(isEmptyQuestion.value));

    function answerQuestion() {
      const a = {
        questionId: question.value.id,
        questionType: question.value.type,
        answer: question.value.type === testQuestionTypes.SELECT ? answer.value : selectedAnswers.value.join(';'),
        isValid: isValid.value,
      };
      emit('answer', a);
    }

    function setAnswer() {
      const a = {
        questionId: question.value.id,
        questionType: question.value.type,
        answer: question.value.type === testQuestionTypes.SELECT ? answer.value : selectedAnswers.value.join(';'),
        isValid: isValid.value,
      };
      emit('setAnswer', a);
    }

    function getAnswer() {
      if (!answers.value.length) {
        return;
      }
      const a = answers.value.filter(a => a.testQuestionId === question.value.id);
      if (!a.length) {
        return;
      }

      if (question.value.type === testQuestionTypes.SELECT) {
        answer.value = a[0].answer;
      }
      selectedAnswers.value = a[0].answer.split(';');
      setAnswer();
    }

    onMounted(() => {
      getAnswer();
    });

    return {
      testQuestionTypes,
      answerQuestion,
      selectedAnswers,
      answer,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>

<i18n locale="en" lang="yaml">
  enterTheAnswer: Enter your answer
</i18n>

<i18n locale="ru" lang="yaml">
  enterTheAnswer: Введите ответ
</i18n>
